<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditFormSupCert" (ngSubmit)="saveOrUpdate()" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid">

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.certification_id.nullable}">{{ fields.certification_code.keyName }}</label></div>
      <div class="ui-grid-col-8">
          <p-dropdown [style]="{'width':'100%'}" formControlName="certification_id" [options]="certs_items" [(ngModel)]="selected_cert"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditFormSupCert" [validation]="fields.certification_id"></app-validation-msg>
        </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" [label]="('supplierCertificationList.add_title' | translate)">
      </button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-certification/supplier-certification-form.component.html